<div ng-style="{'height' : 100%} " class="stepper">
  <!-- <div [style.display]="selected ? 'block' : 'none'">
  </div> -->
  <div class="stepper-top" style="display: inline-flex;">
    <div (click)="onClick(step, i)" class="dhl-stepper-v2" [ngStyle]="widthcss" *ngFor="let step of steps_titles;  let i = index">
      <div *ngIf="(step.valid === false || step.valid === 'default') ">          
        <span *ngIf="step.multipleFormCheck === true && step.valid === false; else default">
          <img class="checkmark-circle" src='./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,22,22))'>
        </span>            
        <ng-template #default>
          <button class="circle" [ngClass]="{'activecircle': selectedIndex === i}">
            <div [ngClass]="{'number': true, 'activenumber': selectedIndex === i}">          
              <span >{{i + 1}}</span>
            </div>
          </button>          
        </ng-template>
      </div>
      <div *ngIf="step.valid === true" style="height: 32px;">
        <span>
          <img class="checkmark-circle" src='./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,900,32,32))'>
        </span>
      </div>      	  
      <div ng-style="{'height': 33%}" class="titlehead" [ngClass]="{'activetitle': selectedIndex === i}">
        {{step.title}}
      </div>
      <div ng-style="{'height': 33%}" class="line" [ngClass]="{'activeline': selectedIndex === i}"></div>
    </div>
  </div>
  <!-- <div ng-style="{'height' : 70%}" class="stepper-form">
    <app-static-form [formIndex]="selectedIndex" (onSubmit)="submit($event)"></app-static-form>
  </div> -->
</div>